import React from 'react';
import "../assets/scss/components/info-chip.scss"

const InfoChip = (props) => {
    return (
        <div className={`info-chip ${(props?.className) ? props.className : ''}`}>
            <div className="info-chip__value">{props.value}</div>
            <div className="info-chip__description">{props.description}</div>
        </div>
    );
};

export default InfoChip;
